import React, { PureComponent } from 'react';

import classNames from 'classnames';
import { ENGAGEMENT_LEVELS } from 'modules/userManager/constants';
import PropTypes from 'prop-types';

import './BigNumbersEngagementBars.scss';

class BigNumbersEngagementBars extends PureComponent {
  static propTypes = {
    activeItem: PropTypes.number
  };

  engagementLevels = ENGAGEMENT_LEVELS.filter((key) => key !== 'none');

  renderBar = (key, idx) => {
    const { activeItem } = this.props;
    const isItemActive = activeItem === idx + 1;
    const barClasses = classNames(
      'engagement-bars',
      `engagement-bars__${key}`,
      { active: isItemActive }
    );

    return <span key={key} className={barClasses} />;
  };

  render() {
    const engagementBars = this.engagementLevels.map(this.renderBar);

    return (
      <div className="engagement-bars__column">
        <div className="engagement-bars__container">{engagementBars}</div>
      </div>
    );
  }
}

export default BigNumbersEngagementBars;
